import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreatePruebaConfesionalRequest extends CreateKeyValueRequest {
  idPersonaAbsolvente!: number;
  idUsuarioResponsable!: number;
  idEstadoPrueba!: number;
  idExpediente!: number;
  idTipoInterviniente!: number;
  fechaAudiencia!: string;               // Formato ISO 8601 (ej. "2025-06-07T00:00:00Z")
  fechaCedulaPresentacion!: string;      // Formato ISO 8601 (ej. "2025-06-07T00:00:00Z")
  fechaCedulaNotificacion!: string;      // Formato ISO 8601 (ej. "2025-06-07T00:00:00Z")
}
